import React from 'react';
import SvgIcon from '../svg/svg';

const Button = ({ index, customClass, onClick, text, icon }) => {
    return (
        <div
            key={index}
            className={`button ${customClass}`}
            onClick={onClick}
        >
            {icon && <SvgIcon icon={icon} />}
            {text}
        </div>
    );
}

export default Button;